import { ActionType, IAssetModel } from "@xala/common-services";
import { IFormValues } from "@xala/common-ui";

export function parseActionTypeString(
  type?: string
): ActionType | undefined {
  if (type == null || type === "") {
    return undefined;
  }
  const values = Object.values(ActionType) as string[];
  return values.includes(type) ? (type as ActionType) : undefined;
}

/**
 * Maps persisted `asset.Action` into Ant Design form field values and UI `actionType` state.
 */
export function mapAssetActionToFormValues(asset: IAssetModel): {
  actionType: ActionType | undefined;
  fields: Partial<IFormValues>;
} {
  const action = asset.Action;
  if (action?.Type == null || action.Type === "") {
    return { actionType: undefined, fields: {} };
  }

  const actionType = parseActionTypeString(action.Type);
  if (actionType == null) {
    return { actionType: undefined, fields: {} };
  }

  const p = action.Payload ?? {};
  const fields: Partial<IFormValues> = {
    ActionType: action.Type,
  };

  switch (actionType) {
    case ActionType.OpenUrl:
      if (p.Url != null) {
        fields.Url = p.Url;
      }
      break;
    case ActionType.OpenScreen:
      if (p.ScreenId != null) {
        fields.ScreenId = p.ScreenId;
      }
      if (p.ScreenName != null) {
        fields.ScreenName = p.ScreenName;
      }
      if (p.ScreenTypeCode != null) {
        fields.ScreenType = p.ScreenTypeCode;
      }
      break;
    case ActionType.OpenMedia:
      if (p.MediaId != null) {
        fields.AssetId = p.MediaId;
      }
      if (p.MediaName != null) {
        fields.AssetTitle = p.MediaName;
      }
      break;
    case ActionType.OpenMediaCollection:
      if (p.MediaCollectionId != null) {
        fields.CollactionId = p.MediaCollectionId;
      }
      if (p.MediaCollectionName != null) {
        fields.CollectionName = p.MediaCollectionName;
      }
      break;
    default:
      break;
  }

  return { actionType, fields };
}
